<template>
  <v-btn icon @click="deletarDados()">
    <v-icon>mdi-delete</v-icon>
  </v-btn>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import { deleteMapaSeparacao } from './Requisicoes';
import {logout} from "@/helpers";

export default {
  components: {
    SysDialog,
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    deletarDados() {
      const parametros = {
        id_grupo_separacao: this.item.id_grupo_separacao,
        filial_destino: this.item.filial_destino,
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        deleteMapaSeparacao(parametros)
          .then(() => this.$emit('atualizar-tela-inicial'))
          .catch(logout)
      );
    },
  },
}
</script>

<style scoped>
li {
  margin: 6px 0px;
}
</style>
